/**
 * @file ラベル要素（Atom）。label要素のラッパー。htmlForでinput要素との紐付けを行う。
 */
import { ReactNode } from 'react';

/** 属性定義 */
type Props = Partial<{
  children: ReactNode;
  htmlFor: string;
  className: string;
}>;

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtLabel = ({ children, htmlFor, className }: Props) => {
  return (
    <label className={className} htmlFor={htmlFor}>
      {children}
    </label>
  );
};

export default AtLabel;
